import React from 'react';
import Header from '../components/Layout';

const App = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default App;
